import { render, staticRenderFns } from "./PrivacyPolicyIntranetView.vue?vue&type=template&id=72bfb870&scoped=true"
import script from "./PrivacyPolicyIntranetView.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyIntranetView.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyIntranetView.vue?vue&type=style&index=0&id=72bfb870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bfb870",
  null
  
)

export default component.exports